export const REDUCED_MOTION_PREFERENCES = ['system', 'on', 'off'] as const;

/** Follow the device's `prefers-reduced-motion` (`system`), always reduce motion (`on`), or never (`off`). */
export type ReducedMotionPreference = (typeof REDUCED_MOTION_PREFERENCES)[number];

export const DEFAULT_REDUCED_MOTION_PREFERENCE: ReducedMotionPreference = 'system';

/** The attribute on `<html>` the CSS fallbacks (the `reduced` mixin) read an explicit choice from. */
export const DOCUMENT_MOTION_ATTRIBUTE = 'data-wh-motion';

/** The attribute's value for a preference: `reduce` for On, `full` for Off, and none when following the device. */
export const documentMotionValue = (preference: ReducedMotionPreference): 'reduce' | 'full' | undefined => {
  switch (preference) {
    case 'on':
      return 'reduce';
    case 'off':
      return 'full';
    default:
      return undefined;
  }
};

/** Puts the preference on `<html>`, or takes the attribute off when following the device. */
export const applyDocumentMotion = (preference: ReducedMotionPreference, doc: Document = document): void => {
  const value = documentMotionValue(preference);
  if (value) {
    doc.documentElement.setAttribute(DOCUMENT_MOTION_ATTRIBUTE, value);
  } else {
    doc.documentElement.removeAttribute(DOCUMENT_MOTION_ATTRIBUTE);
  }
};
